export class TokenModel {
    constructor(public token: string, public expiryDate: Date, public refreshToken: string){}
}